import { render } from "./DocumentationComponent.vue?vue&type=template&id=8fa4ee94&scoped=true"
import script from "./DocumentationComponent.vue?vue&type=script&lang=js"
export * from "./DocumentationComponent.vue?vue&type=script&lang=js"

import "./DocumentationComponent.vue?vue&type=style&index=0&id=8fa4ee94&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa4ee94"]])

export default __exports__